import React from "react"
import clsx from "clsx"
import { formatHours } from "../lib/hours"

const RowTotal = ({ total, base }) => {
  const ratio = base > 0 ? total / base : 0
  const tone  = ratio > 1.001 ? "bg-rose-500" : ratio >= 0.9 ? "bg-emerald-500" : "bg-brand-400"
  return (
    <div className="flex flex-col justify-center gap-1 px-3 border-b border-slate-100 bg-white">
      <div className="flex items-baseline justify-end gap-1 tabular-nums">
        <span className={clsx("text-[12.5px] font-semibold", ratio > 1.001 ? "text-rose-600" : "text-slate-800")}>{formatHours(total)}</span>
        {base > 0 && <span className="text-[10.5px] text-slate-400">/ {formatHours(base)}</span>}
      </div>
      {base > 0 && (
        <div className="h-1 rounded-full bg-slate-100 overflow-hidden">
          <div className={clsx("h-full rounded-full transition-[width] duration-300", tone)} style={{ width: `${Math.min(100, ratio * 100)}%` }} />
        </div>
      )}
    </div>
  )
}

export default RowTotal
